module.exports = __webpack_public_path__ + "img/bf@2x.79ba87b1.png";